export const globalMessages = {
  thankYouForm:
    'Thank you for your request! Please check your inbox for an email from our team. ' +
    'If you do not see it, please check your junk or spam folder.',
};
